export default __webpack_public_path__ + "static/media/sfondodivestiti.f12a502d.png";